import { ThresholdLevel, VistaDiagnosticsLog } from '@vista/diagnostics';
// Creating instance and providing default configuration
const vistaDiagnosticLogInstance = new VistaDiagnosticsLog();
vistaDiagnosticLogInstance.configure('console', {
    thresholdLevel: ThresholdLevel.INFO,
    messagePrefix: 'Vista CXM Rules Client'
});
export const logger = vistaDiagnosticLogInstance;
